import { makeStyles } from '@material-ui/styles';

import buttonIcon from 'public/images/scrollToBottomButton.svg';

const CONTROL_BAR_HEAIGHT = 76;

export default makeStyles(theme => ({
  container: {
    height: '100%',
    maxHeight: '100%',
    width: '100%',
    display: 'flex',
    flexFlow: 'column',
  },
  messages: {
    flexGrow: 1,
    flexShrink: 1,
    height: `calc(100% - ${CONTROL_BAR_HEAIGHT}px)`,
    overflow: 'auto',
  },
  messagesContainer: {
    padding: [0, 25, 0, 25],
    width: '100%',
    height: '100%',
    '& button[class*="react-scroll-to-bottom"]': {
      backgroundColor: 'transparent',
      backgroundImage: `url(${buttonIcon})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      width: 38,
      height: 38,
      borderRadius: '50%',
      bottom: 20,
      zIndex: 2,
      [theme.breakpoints.up('mobile')]: {
        width: 48,
        height: 48,
      },
    },
  },
  scrollView: {
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/Chat/useStyles.js